import React from 'react';
import moment from 'moment';
import Interweave from 'interweave';
import * as StyledArticleDetails from './articleDetails.styles';
import {
	Container, Columns,
} from '../base';

const ArticleDetails = ({
	Name,
	ArticleContent,
	ArticleImages,
	ArticlePublishedDate
}) => {
	return (
		<StyledArticleDetails.Wrapper>
			<Container>
				<Columns>
					<StyledArticleDetails.ContentColumn tablet={8 / 12}>
						<StyledArticleDetails.Content>
							<StyledArticleDetails.Date>
								{moment(ArticlePublishedDate).format('DD. MMMM YYYY')}
							</StyledArticleDetails.Date>
							<StyledArticleDetails.Title>
								{Name}
							</StyledArticleDetails.Title>
							<StyledArticleDetails.Text>
								<Interweave content={ArticleContent} />
							</StyledArticleDetails.Text>
						</StyledArticleDetails.Content>
					</StyledArticleDetails.ContentColumn>
					<StyledArticleDetails.ImageColumn tablet={4 / 12}>
						{
							ArticleImages && ArticleImages.length > 0 && (
								<StyledArticleDetails.Image
									image={`${ArticleImages[0].Url}?width={width}&mode={crop}`}
									tabletWidth="400"
									tabletHeight="800"
									desktopWidth="500"
									desktopHeight="700"
									retinaWidth="1000"
									retinaHeight="1400" />
							)
						}
					</StyledArticleDetails.ImageColumn>
				</Columns>
			</Container>
		</StyledArticleDetails.Wrapper>
	);
};

export default ArticleDetails;
